// UX Audit: shared arrows + progress dots controller for horizontal scroll areas
(function () {
  'use strict';

  function initControls(controls) {
    if (controls.hasAttribute('data-ux-init')) return;
    controls.setAttribute('data-ux-init', '');

    var target = document.getElementById(controls.getAttribute('data-ux-target'));
    if (!target) return;

    var prevButton = controls.querySelector('[data-ux-prev]');
    var nextButton = controls.querySelector('[data-ux-next]');
    var dotsWrap = controls.querySelector('[data-ux-dots]');
    var pages = 1;
    var scrollTicking = false;

    function maxScroll() {
      return target.scrollWidth - target.clientWidth;
    }

    function currentPage() {
      var width = target.clientWidth;
      if (width === 0) return 0;
      if (target.scrollLeft >= maxScroll() - 4) return pages - 1;
      return Math.min(pages - 1, Math.round(target.scrollLeft / width));
    }

    function update() {
      var index = currentPage();

      if (prevButton) prevButton.disabled = target.scrollLeft <= 4;
      if (nextButton) nextButton.disabled = target.scrollLeft >= maxScroll() - 4;

      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }
    }

    function rebuild() {
      var width = target.clientWidth;
      var max = maxScroll();

      if (width === 0 || max <= 4) {
        controls.hidden = true;
        return;
      }

      controls.hidden = false;
      pages = Math.max(1, Math.ceil(max / width) + 1);

      if (dotsWrap && dotsWrap.children.length !== pages) {
        dotsWrap.innerHTML = '';

        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'tap-area';
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.setAttribute('data-ux-page', String(i));
          dotsWrap.appendChild(dot);
        }
      }

      update();
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        target.scrollBy({ left: -target.clientWidth, behavior: 'smooth' });
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        target.scrollBy({ left: target.clientWidth, behavior: 'smooth' });
      });
    }

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-ux-page]');
        if (!dot) return;
        var index = parseInt(dot.getAttribute('data-ux-page'), 10);
        target.scrollTo({ left: Math.min(index * target.clientWidth, maxScroll()), behavior: 'smooth' });
      });
    }

    target.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        scrollTicking = false;
        update();
      });
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(rebuild).observe(target);
    } else {
      window.addEventListener('resize', rebuild);
    }

    rebuild();
  }

  function setup() {
    document.querySelectorAll('[data-ux-scroll-controls]').forEach(initControls);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  // UX Audit: re-init after theme editor re-renders a section (fresh nodes lack data-ux-init)
  document.addEventListener('shopify:section:load', setup);
})();
